import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Doc, { IDocQueryParams } from "models/document";
import Field from "models/field";
import GeneratedDoc from "models/generated-doc";

export interface DocumentGeneratorState {
    filters: IDocQueryParams,
    docs: Doc[],
    doc: Doc | null,
    docFields: Field[]
    savedValues: any
    generateDocError: string | null,
    processingDocument: boolean,
    viewingDocument: boolean,
    generatedDocs: GeneratedDoc[],
    generatedDocCount: number,
    isLoadingGenratedDocs: boolean,
}

export const initialState: DocumentGeneratorState = {
    filters: {},
    docs: [],
    doc: null,
    docFields: [],
    savedValues: {},
    generateDocError: null,
    processingDocument: false,
    viewingDocument: false,
    generatedDocs: [],
    generatedDocCount: 0,
    isLoadingGenratedDocs: true,
};

const documentGeneratorSlice = createSlice({
    name: "document-generator-slice",
    initialState,
    reducers: {
        setDocuments(state, { payload }: PayloadAction<Doc[]>) {
            state.docs = payload
        },
        setDocumentQuery(state, { payload }: PayloadAction<IDocQueryParams>) {
            state.filters = payload
        },
        setDocument(state, { payload }: PayloadAction<Doc | null>) {
            state.doc = payload
        },
        setDocumentFields(state, { payload }: PayloadAction<Field[]>) {
            state.docFields = payload
        },
        setDocumentTemplateValue(state, { payload }: PayloadAction<any>) {
            state.savedValues = payload
        },
        setDocumentTemplateValues(state, { payload }: PayloadAction<any>) {
            state.savedValues = payload
        },
        startProcessesingDocument(state) {
            state.processingDocument = true
        },
        finishProcessesingDocument(state, { payload }: PayloadAction<string>) {
            state.processingDocument = false
            state.generateDocError = payload
        },
        startViewingDocument(state) {
            state.viewingDocument = true
        },
        finishViewingDocument(state) {
            state.viewingDocument = false
        },
        setGenerationError(state, { payload }: PayloadAction<string>) {
            state.generateDocError = payload
        },
        setGeneratedDocs(state, { payload }: PayloadAction<GeneratedDoc[]>) {
            state.generatedDocs = payload
        },
        setGeneratedDocCount(state, { payload }: PayloadAction<number>) {
            state.generatedDocCount = payload
        },
        setIsLoadingGeneratedDocs(state, { payload }: PayloadAction<boolean>) {
            state.isLoadingGenratedDocs = payload
        },
        upsertGeneratedDoc(state, { payload }: PayloadAction<GeneratedDoc>) {
            const index = state.generatedDocs.findIndex(d => d.id === payload.id);
            if (index !== -1) {
                state.generatedDocs[index] = { ...payload };
            } else {
                state.generatedDocs.push(payload);
            }
        }

    },
});

export const {
    setDocuments,
    setDocumentQuery,
    setDocument,
    setDocumentFields,
    setDocumentTemplateValue,
    startProcessesingDocument,
    finishProcessesingDocument,
    startViewingDocument,
    finishViewingDocument,
    setGenerationError,
    setGeneratedDocs,
    setGeneratedDocCount,
    setIsLoadingGeneratedDocs,
    upsertGeneratedDoc
} = documentGeneratorSlice.actions

export default documentGeneratorSlice.reducer;
